import Vue from 'vue';
import { CHART_TICK, DISPLAY_LIST_TYPE } from '../classes/Const';
import Task from '../classes/Task';
import Member from '../classes/Member';
import Project from '../classes/Project';

const _innerWidth = (state) => {
	return 24 * 60 / state.chart.tick.minutes * state.chart.tick.size;
};
const _listWidth = (state) => {
	let width = 300 + state.position.board_left;
	return width;
};

const MODE = {
	VIEW: 0,
	EDIT: 1,
};

const state = {
	mode: MODE.VIEW,
	display_list_type: DISPLAY_LIST_TYPE.MEMBER,
	is_all_expanded: true,
	position: {
		hscroll: 0,
		board_left: 0,
	},
	chart: {
		is_scrolling_to_now: false,
		now: null,
		tick: CHART_TICK.MD,
	},
	list_row_state: [
		{},	// MEMBER
		{},	// PROJECT
	],
};

const getters = {
	current_day_as_date(state, getters, rootState) {
		return rootState.current_day;
	},
	chartTick: function(state) {
		return state.chart.tick;
	},
	chartOffset: (state, getters) => (now) => {
		if (now == null)
			return -1;
		let tick = getters.chartTick;
		let minutes = (now.getHours() * 60) + now.getMinutes();

		return minutes / tick.minutes * tick.size;
	},
	chartOffsetNow(state, getters) {
		return getters.chartOffset(state.chart.now);
	},
	chartOffsetNowLine(state, getters) {
		let time = state.chart.now;
		let day = getters.current_day_as_date;
		
		let position = -1;
		let visible = (time !== null) &&
			(day.getFullYear() === time.getFullYear()) &&
			(day.getMonth() === time.getMonth()) &&
			(day.getDate() === time.getDate());
		if (visible) {
			position = getters.chartOffset(time);
		}
		
		return position;
	},
	innerWidth: function(state) {
		return _innerWidth(state);
	},
	listWidth: function(state) {
		return _listWidth(state);
	},
	hscroll: function(state) {
		return state.position.hscroll;
	},
	boardLeftPosition: function(state) {
		return state.position.board_left;
	},
	isEditable: function(state) {
		return state.mode === MODE.EDIT;
	},
	isScrollingToNow: function(state) {
		return state.chart.is_scrolling_to_now;
	},
	displayListType: function(state) {
		return state.display_list_type;
	},
	isDisplayMemberList: function(state) {
		return state.display_list_type === DISPLAY_LIST_TYPE.MEMBER;
	},
	isAllExpanded: function(state) {
		return state.is_all_expanded;
	},
	display_list: function (state, getters, rootState, rootGetters) {
		let display_tasks = new Array();
		rootGetters.dataTask.forEach( t => {
			let display_schedueles = new Array();
			t.schedules.forEach( s => {
				if (s.isOverlapOneDay(getters.current_day_as_date)) {
					display_schedueles.push(s);
				}
			});
			if (display_schedueles.length > 0) {
				display_tasks.push(new Task({
					code: t.code,
					name: t.name,
					schedules: display_schedueles,
					project_code: t.project_code,
					member_code: t.member_code,
					remarks: t.remarks,
					seq: 0,
					is_updated: false,
				}));
			}
		});

		if (getters.displayListType === DISPLAY_LIST_TYPE.MEMBER) {
			return rootGetters.dataMember.map( m => {
				let tasks = display_tasks.filter(t => t.member_code == m.code);
				let schedules = new Array();
				tasks.forEach(t => {
					t.schedules.forEach(s => {
						schedules.push(s);
					});
				});
				if (tasks.length !== 0) {	
					_createScheduleListRowState(state.list_row_state[DISPLAY_LIST_TYPE.MEMBER], {
						code: m.code,
						is_expanded: false,
					});
				}
				return new Member(Object.assign(Object.assign({}, m), {
					children: tasks,
					schedules: schedules,
					is_updated: false,
				}));
			});
		} else {
			let display_projcets = new Array();
			rootGetters.dataProject.forEach( p => {
				let pushOk = false;
				p.schedules.forEach( s => {
					if (s.isOverlapOneDay(getters.current_day_as_date)) {
						pushOk = true;
					}
				});
				if (pushOk) {
					let tasks = display_tasks.filter(t => t.project_code == p.code);
					if (tasks.length !== 0) {	
						_createScheduleListRowState(state.list_row_state[DISPLAY_LIST_TYPE.PROJECT], {
							code: p.code,
							is_expanded: false,
						});
					}
					display_projcets.push(new Project(Object.assign(Object.assign({}, p), {
						children: tasks,
						is_updated: false,
					})));
				}
			});
			return display_projcets;
		}
	},
	isExpandedScheduleListRow: (state, getters) => (row) => {
		let list_row_state = getters.displayListType === DISPLAY_LIST_TYPE.MEMBER ? state.list_row_state[DISPLAY_LIST_TYPE.MEMBER]
										   : state.list_row_state[DISPLAY_LIST_TYPE.PROJECT];	   
		if (list_row_state[row.code] === undefined)
			return false;
		return list_row_state[row.code].is_expanded;
	},
	computeWidthFromMinutes: (state, getters) => (minutes) => {
		let tick = getters.chartTick;
		return minutes / tick.minutes * tick.size;
	},
};

const _createScheduleListRowState = (list_row_state, {code, is_expanded}) => {
	if (list_row_state[code] !== undefined)
		return;
	list_row_state[code] = {
		code: code,
		is_expanded: is_expanded,
	};
};
const _setExpandedScheduleListRowState = (state, list_type, {code, is_expanded}) => {
	let list_row_state = state.list_row_state[list_type];
	let row = list_row_state[code];
	if (row === undefined)
		return false;

	Vue.set(row, 'is_expanded', is_expanded);
	Vue.set(list_row_state, code, row);
	Vue.set(state.list_row_state, list_type, list_row_state);

	return true;
};

const _isAllExpand = (list_row_state) => {
	return !Object.keys(list_row_state).map(key => list_row_state[key]).some(row_state => row_state.is_expanded);
};

const mutations = {
	initState: function(state) {
		state.mode = MODE.VIEW;
		state.display_list_type = DISPLAY_LIST_TYPE.MEMBER;
		state.is_all_expanded = true;
		// position
		state.position.hscroll = 0;
		state.position.board_left = 0;
		// chart
		state.chart.is_scrolling_to_now = false;
		state.chart.tick = CHART_TICK.MD;
	},
	nowTime: function(state, time) {
		state.chart.now = time;
	},
	hscroll: function(state, pos) {
		let max = _innerWidth(state) - (this.state.window.size.width - _listWidth(state));

		if (pos < 0)
			pos = 0;
		if (max < pos)
			pos = max;

		state.position.hscroll = pos;
	},
	setModeView: function(state) {
		state.mode = MODE.VIEW;
	},
	setModeEdit: function(state) {
		state.mode = MODE.EDIT;
	},
	setScrollingToNow: function(state, value) {
		state.chart.is_scrolling_to_now = value;
	},
	setDisplayListType: function(state, value) {
		state.display_list_type = value;
	},
	toggleExpand: function (state, value) {
		let list_row_state = state.list_row_state[state.display_list_type];
		_setExpandedScheduleListRowState(state, state.display_list_type, {
			code: value,
			is_expanded: !list_row_state[value].is_expanded,
		});
		state.is_all_expanded = _isAllExpand(list_row_state);
	},
	setToggleAllExpand: function (state, list_type) {
		let list_row_state = state.list_row_state[list_type];
		state.is_all_expanded = _isAllExpand(list_row_state);
	},
	setExpandedScheduleListRowAll: function(state, {list_type, is_expanded}) {
		let list_row_state = state.list_row_state[list_type];
		Object.keys(list_row_state).forEach(code => {
			_setExpandedScheduleListRowState(state, list_type, {
				code: code,
				is_expanded: is_expanded,
			});
		});
	},
};

const actions = {
	hscrollMove: function({commit}, amount) {
		if (isNaN(amount))
			return;

		let pos = state.position.hscroll - amount;
		commit('hscroll', pos);
	},
	moveToToday: function({getters, commit, dispatch}) {
		let now = new Date();
		let beginning = this.getters.createDateBeginningDay(now);
		this.commit('setCurrentDate', beginning);
		dispatch('moveToNow');
	},
	moveToNow: function({getters, commit}) {
		commit('nowTime', new Date());
		let offset = getters.chartOffsetNow;
		let tick = getters.chartTick;

		offset -= tick.size * 4;

		commit('hscroll', offset);
		commit('setScrollingToNow', true);
	},
	setDisplayListTypeMember: function(store) {
		store.commit('setDisplayListType', DISPLAY_LIST_TYPE.MEMBER);
	},
	setDisplayListTypeProject: function(store) {
		store.commit('setDisplayListType', DISPLAY_LIST_TYPE.PROJECT);
	},
	toggleExpand: function(store, params) {
		store.commit('toggleExpand', params);
	},
	foldingListMemberAll: function(store) {
		store.commit('setExpandedScheduleListRowAll', {
			list_type: DISPLAY_LIST_TYPE.MEMBER,
			is_expanded: false,
		});
	},
	foldingListProjectAll: function(store) {
		store.commit('setExpandedScheduleListRowAll', {
			list_type: DISPLAY_LIST_TYPE.PROJECT,
			is_expanded: false,
		});
	},
	expandingListMemberAll: function(store) {
		store.commit('setExpandedScheduleListRowAll', {
			list_type: DISPLAY_LIST_TYPE.MEMBER,
			is_expanded: true,
		});
	},
	expandingListProjectAll: function(store) {
		store.commit('setExpandedScheduleListRowAll', {
			list_type: DISPLAY_LIST_TYPE.PROJECT,
			is_expanded: true,
		});
	},
	setToggleAllExpandMember: function(store) {
		store.commit('setToggleAllExpand', DISPLAY_LIST_TYPE.MEMBER);
	},
	setToggleAllExpandProject: function(store) {
		store.commit('setToggleAllExpand', DISPLAY_LIST_TYPE.PROJECT);
	},
};

export default {
	name: 'chart',
	namespaced: true,
	state: state,
	getters: getters,
	mutations: mutations,
	actions: actions,
};
